// src/api/adminCommunity.js
import api from "../services/api";

export async function adminCreateArticle(body) {
    const { data } = await api.post("/api/admin/community/articles", body);
    return data;
}
export async function adminUpdateArticle(id, body) {
    const { data } = await api.put(`/api/admin/community/articles/${id}`, body);
    return data;
}
export async function adminPublishArticle(id) {
    await api.post(`/api/admin/community/articles/${id}/publish`);
}

export async function adminUpload(file, folder = "articles") {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("folder", folder);
    const { data } = await api.post("/api/admin/uploads", fd, {
        // let the browser set multipart boundary
    });
    // -> { publicUrl, objectPath }
    return data;
}

export async function adminGetArticle(id) {
    const { data } = await api.get(`/api/admin/community/articles/${id}`);
    return data;
}

export async function adminListArticles({ q = "", page = 0, size = 20 } = {}) {
    const params = { q, page, size };
    const { data } = await api.get("/api/community/articles", { params });
    return data;
}
